import { render, staticRenderFns } from "./do_index.vue?vue&type=template&id=1648a644&scoped=true&"
import script from "./do_index.vue?vue&type=script&lang=js&"
export * from "./do_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648a644",
  null
  
)

export default component.exports